import { type HueName, fontSize, fontWeight, lineHeight, radius, shadow, space } from './primitives'
import { type ThemeMode, buildSemantic } from './semantic'

const px = (n: number) => `${n}px`

/**
 * Đổi token thành bảng biến CSS `--vbdt-<nhóm>-<vai trò>`.
 * Đây là cầu nối DUY NHẤT từ TypeScript sang SCSS.
 */
export const buildCssVars = (mode: ThemeMode, hue: HueName): Record<string, string> => {
  const s = buildSemantic(mode, hue)
  const out: Record<string, string> = {}

  for (const [group, entries] of Object.entries(s)) {
    for (const [role, value] of Object.entries(entries as Record<string, string>)) {
      const kebab = role.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)
      out[`--vbdt-color-${group}-${kebab}`] = value
    }
  }

  for (const [k, v] of Object.entries(space)) out[`--vbdt-space-${k}`] = px(v)
  for (const [k, v] of Object.entries(radius)) out[`--vbdt-radius-${k}`] = px(v)
  for (const [k, v] of Object.entries(fontSize)) out[`--vbdt-font-size-${k}`] = px(v)
  for (const [k, v] of Object.entries(lineHeight)) out[`--vbdt-line-height-${k}`] = px(v)
  for (const [k, v] of Object.entries(fontWeight)) out[`--vbdt-font-weight-${k}`] = String(v)
  for (const [k, v] of Object.entries(shadow)) out[`--vbdt-shadow-${k}`] = v

  return out
}

export const applyCssVars = (root: HTMLElement, mode: ThemeMode, hue: HueName): void => {
  for (const [key, value] of Object.entries(buildCssVars(mode, hue))) {
    root.style.setProperty(key, value)
  }
}
